<template>
    <div v-show="showImage">
        <div v-if="deleteInformVisible">
            <div>
                <div class="modal-header" style="top:0; right: 0;">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" @click="dismiss" width="20" height="20"
                         style="cursor:pointer;">
                        <path d="M2.586 2.586a2 2 0 012.828 0L32 29.172 58.586 2.586a2 2 0 112.828 2.828L34.828 32l26.586 26.586a2 2 0 11-2.828 2.828L32 34.828 5.414 61.414a2 2 0 11-2.828-2.828L29.172 32 2.586 5.414a2 2 0 010-2.828z" />
                    </svg>
                </div>

                <div style="display: flex; justify-content: center; align-items: center; min-height: 100vh;">
                    <div style="top: 150px;position: absolute;">
                        <div id="txtContainer" style="display: inline-block; padding-bottom: 40px;">
                            <h1 style="font-family: proxima-nova, sans-serif; font-weight: 700; padding-bottom: 40px; color: black; margin: 0; white-space: pre-wrap; text-align: left;">
                                {{ headerText }}
                            </h1>
                            <p style="font-family: proxima-nova, sans-serif; font-weight: 400; text-align: left; color: black; margin: 0; white-space: pre-wrap; font-size: 18px;">
                                {{ bodyText }}
                            </p>
                        </div>

                        <div style="text-align: center; color: black;">
                            <img src="/check-success.svg" height="75"> <img />
                        </div>
                    </div>
                    <p id="lastLine" style="font-family: proxima-nova, sans-serif; font-weight: 400; position: absolute; font-weight: 400; color: black; margin: 0; white-space: pre-wrap; font-size: 18px; ">{{$t('components.viewerImage.bodyTextSecond')}}.</p>
                </div>
            </div>
        </div>

        <div class="image-column" style="display: flex; flex-direction: column; gap: 20px;">
            <div v-if="originalAvailable" class="col-xs-2 image-container" style="padding-bottom:0px !important">
                <img class="responsive" :src="originalUrl">
            </div>

            <div v-if="gifAvailable" class="col-xs-2 image-container" style="padding-bottom:0px !important">
                <img class="responsive" :src="gifUrl">
            </div>

            <div v-if="boomerangAvailable" class="col-xs-2 image-container" style="padding-bottom:0px !important">
                <img class="responsive" :src="boomerangUrl">
            </div>
        </div>

        <div class="text-center" id="textWrapper">
            <p>
                <span id="holdText" v-html="$t('components.viewerImage.holdDescription')"></span>
            </p>

            <div style="display: inline-block; text-align:center; position: relative; padding-top:11px;min-width:100%">
                <div style="color: black; text-align: center; border: none; opacity: 90%; cursor: pointer; min-width:100%"
                     class="SelectedImgButton btn" @click="requestDelete" v-bind:style="{ backgroundColor: deleteBtnText == $t('components.viewerImage.deleteBtnText') || deleteBtnText == $t('components.viewerImage.deleteBtnTextDone') ? '#FFFFFF' : '#FF6D6A', border: deleteBtnText != $t('components.viewerImage.deleteBtnText') ? '1px solid black' : 'none'}">
                    <span style="text-align:center">
                        <span :class="deleteBtnText == $t('components.viewerImage.deleteBtnTextConfirm') ? 'normal_BtnTextClicked' : 'normal_BtnText'">{{ deleteBtnText }} <img :src="'/icons8-trash_can_exp_210C2C.svg'" /> </span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import APIService from '../services/APIService';

    export default {
        name: "ViewerImage",
        props: {
            showImage: {
                type: Boolean
            },
            originalUrl: {
                type: String
            },
            gifUrl: {
                type: String
            },
            boomerangUrl: {
                type: String
            },
            Parms: {
                type: Object
            },
            checksum: {
                type: String
            }
        },
        data() {
            return {
                deleteBtnText: this.$t('components.viewerImage.deleteBtnText'),
                headerText: this.$t('components.viewerImage.headerText'),
                deleteInformVisible: false,
                bodyText: this.$t('components.viewerImage.bodyText'),
                overlayText: this.$t('components.viewerImage.gifText')
            }
        },
        computed: {
            originalAvailable() {
                return this.originalUrl !== null && this.originalUrl !== '';
            },
            gifAvailable() {
                return this.bottomImage !== null && this.bottomImage !== '';
            },
            boomerangAvailable() {
                return this.boomerangUrl !== null && this.boomerangUrl !== ''
            },
            getImageDeletionEndpoint() {
                return `/sharing/image/hiddenstatus/${this.Parms.domain}/${this.Parms.order}/${this.Parms.file}/${this.Parms.type}/${this.Parms.onedaybutton}/${this.Parms.connectionState}/${this.checksum}`
            }
        },
        updated() {
            document.body.style.background = this.deleteInformVisible ? 'linear-gradient(45deg, rgba(245, 245, 245, 1) 0%, rgba(245, 245, 245, 1) 50%, rgba(245, 245, 245, 1) 100%)' : 'linear-gradient(45deg, rgba(33,12,44,1) 0%, rgba(33,12,44,1) 50%, rgba(61,34,83,1) 100%)';
            document.getElementById('htmlID').style.background = this.deleteInformVisible ? 'linear-gradient(45deg, rgba(245, 245, 245, 1) 0%, rgba(245, 245, 245, 1) 50%, rgba(245, 245, 245, 1) 100%)' : 'linear-gradient(45deg, rgba(33,12,44,1) 0%, rgba(33,12,44,1) 50%, rgba(61,34,83,1) 100%)';
            document.body.style.overflow = this.deleteInformVisible ? 'hidden' : 'visible';

            const mainLogo = document.getElementById('mainLogo');
            mainLogo.style.top = '20px';
            mainLogo.style.left = '20px';
            mainLogo.style.position = 'absolute';
            mainLogo.src = this.deleteInformVisible ? '/myselie_logo_3.1_py.svg' : '/myselie_logo_3.1_wy.svg';

            const txtContainer = document.getElementById('txtContainer');
            if (txtContainer) {
                const lastLine = document.getElementById('lastLine');
                const coordinates = txtContainer.getBoundingClientRect();

                lastLine.style.top = coordinates.bottom - 40 + 'px';
                lastLine.style.left = coordinates.left + 'px';
            }
        },
        methods: {
            swapImages() {
                if (this.topImage === this.originalUrl) {
                    this.topImage = this.gifUrl;
                    this.bottomImage = this.boomerangUrl;
                    this.overlayText = this.$t('components.viewerImage.boomerangText');
                } else if (this.topImage === this.gifUrl) {
                    this.topImage = this.boomerangUrl;
                    this.bottomImage = this.originalUrl;
                    this.overlayText = this.$t('components.viewerImage.imageText');
                } else if (this.topImage === this.boomerangUrl) {
                    this.topImage = this.originalUrl;
                    this.bottomImage = this.gifUrl;
                    this.overlayText = this.$t('components.viewerImage.gifText');
                }
            },
            dismiss() {
                this.deleteInformVisible = false;
                location.reload();
            },
            async requestDelete() {
                switch (this.deleteBtnText) {
                    case this.$t('components.viewerImage.deleteBtnText'): {
                        this.deleteBtnText = this.$t('components.viewerImage.deleteBtnTextConfirm');
                        break;
                    }
                    case this.$t('components.viewerImage.deleteBtnTextConfirm'): {
                        this.deleteBtnText = this.$t('components.viewerImage.deleteBtnTextDone');
                        this.deleteInformVisible = !this.deleteInformVisible;
                        const result = await this.requestImageDeletion();
                        console.info(result);
                        break;
                    }
                    default: {
                        console.info('anmodning allerede afsendt');
                        break;
                    }
                }
            },
            async requestImageDeletion() {
                const response = await APIService.PUT(this.getImageDeletionEndpoint, {
                    imageName: this.Parms.file + '.' + this.Parms.type,
                    hidden: true,
                    deleteRequested: true
                })
                return response.status;
            }
        }
    }
</script>

<style scoped>
    #holdText {
        font-size: 24px;
        font-weight: 700;
    }

    p {
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .SelectedImgButton {
        border-radius: 50rem;
        text-align: center;
        white-space: break-spaces;
        line-height: 1;
        padding-top: 16px;
    }

        .SelectedImgButton img {
            height: 12px;
            width: 12px;
            position: relative;
        }


    .modal {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;
        background-color: #f5f5f5;
        width: 100%;
        min-height: 100vh;
        overflow-y: auto;
        flex-direction: column;
    }

    .modal-header {
        position: absolute;
        top: 0;
        right: 5px;
        z-index: 1000;
        border: none;
    }

    .image-container {
        position: relative;
        width: 100%;
    }
</style>